/**
 * Generate unique navigation ID from label
 * Converts label to kebab-case and prefixes with 'nav-' for accessibility
 * @param {string} label - Label text or i18n key
 * @returns {string} Kebab-case ID with 'nav-' prefix
 */
export const generateNavigationId = (label: string): string => {
  const kebabCase = label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-') // NOSONAR - replace non-alphanumeric with hyphens
    .replace(/(?:^-+|-+$)/g, '') // NOSONAR - trim leading/trailing hyphens
  return `nav-${kebabCase}`
}

/**
 * Format count for display in badges
 * Shows actual count up to 99, then '99+' for larger numbers
 * Returns empty string for zero or negative counts
 * @param {number} count - Count value
 * @returns {string} Formatted count string
 */
export const formatCount = (count: number): string => {
  if (count <= 0) {
    return ''
  }
  if (count > 99) {
    return '99+'
  }
  return count.toString()
}
